// =====================================
//
//   CMS 部落格列表
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSBlogListController", ['$scope', '$stateParams', '$rootScope', 'CMSService', '$WebTitle', '$timeout',
    function($scope, $stateParams, $rootScope, CMSService, $WebTitle, $timeout) {

        // --------------------------------
        // 取得更多部落格文章列表
        // --------------------------------
        var loadMoreList = function() {

            if($scope.isLoading || $scope.isEmpty || $scope.isNoMore) {
                return;
            }

            getBlogList();
        }

        // --------------------------------
        // [privete] 取得部落格文章列表
        // --------------------------------
        var getBlogList = function() {

            if($scope.isLoading) {
                return;
            }

            // 切換state時，infinit scroll 會立刻做事，這段是防止在某個分類下會拿到全部未分類的資料
            if($scope.category && (!$scope.categoryItem || $scope.categoryItem.key != $scope.category)) {
                return;
            }

            var id = $scope.categoryItem ? $scope.categoryItem._id : undefined;
            $scope.isLoading = true;

            CMSService.getBlogList(id, $scope.sort, $scope.page).then(function(result) {

                if(result) {
                    if(Array.isArray(result.results) && result.results.length > 0) {
                        Array.prototype.push.apply($scope.blogList, result.results);
                    } else if($scope.blogList.length > 0) {
                        $scope.isNoMore = true;
                    } else if($scope.blogList.length == 0) {
                        $scope.isEmpty = true;
                    }
                } else {
                    $scope.isError = true;
                }

                $scope.page++;
                $scope.isLoading = false;

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
            })
        }

        // --------------------------------
        // [privete] 取得部落格分類列表
        // --------------------------------
        var getBlogCategoryList = function() {

            CMSService.getBlogCategoryList().then(function(result) {

                if(Array.isArray(result) && result.length > 0) {
                    $scope.categoryList = result;
                }
            })
        }

        // --------------------------------
        // [privete] 取得部落格分類資訊
        // --------------------------------
        var getBlogCategory = function() {

            if($scope.category) {
                CMSService.getBlogCategory($scope.category).then(function(result) {

                    if(result) {
                        $scope.categoryItem = result;

                        getBlogList();
                    }
                })
            } else {
                getBlogList();
            }

            $WebTitle.setWebTitle('部落格 | inif印衣服，巧昱服飾設計有限公司');
        }

        var toggleCategoryMenuBar = function() {

            $scope.isShowSortMenu = false;
            $scope.isShowCategoryMenu = !$scope.isShowCategoryMenu;
        }

        var toggleSortMenuBar = function() {

            $scope.isShowCategoryMenu = false;
            $scope.isShowSortMenu = !$scope.isShowSortMenu;
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {
            getBlogCategoryList();
            getBlogCategory();
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.page = 1;
        $scope.sort = $stateParams.sort || 'time';
        $scope.category = $stateParams.category;
        $scope.categoryItem;

        $scope.categoryList = [];
        $scope.blogList = [];
        $scope.isLoading = false;
        $scope.isNoMore = false;
        $scope.isEmpty = false;
        $scope.isError = false;
        $scope.isShowSortMenu = false;
        $scope.isShowCategoryMenu = false;

        //==========================
        //  Methods
        //==========================
        $scope.loadMoreList = loadMoreList;
        $scope.toggleCategoryMenuBar = toggleCategoryMenuBar;
        $scope.toggleSortMenuBar = toggleSortMenuBar;

        //==========================
        //  Init
        //==========================
        init();
    }
]);